export default "__VITE_ASSET__DCSJYDuB__"